
/*eslint-disable*/
export default {
    baseUrl:appConfig.baseUrl,
    uploadUrl:appConfig.uploadUrl,
    versionInfo:appConfig.versionInfo,
    WebSocket:appConfig.WebSocket
 }
